// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3q8_l","title":"AfterFrontImage_title__2nbid"};